import { h } from 'preact';
import React, { Component } from 'react';

import './Stacks.css';

export default class Accordion extends Component {
  state = {
    open: false
  }
  toggleAccordion = () => {
    const panel = this.panel;
    const open = !this.state.open;
    this.setState({ open })
    if (!open) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + 'px';
    }
  }
  render() {
    const { stack, loading } = this.props;
    const { open } = this.state;

    return (
      <div className="stack">
        <button
          className={open ? 'accordion active' : 'accordion'}
          style={this.props.accordionStyles}
          onClick={loading ? null : this.toggleAccordion}
        >
          {stack.name}
          {loading ? null : <span className={open ? 'chevron up' : 'chevron down'} />}
        </button>
        <div ref={c => this.panel = c} className="panel">
          <p style={{ ...this.props.panelStyles }}>{stack.description}</p>
        </div>
      </div>
    );
  }
}
